const env = process.env;
const { REACT_APP_LOG_ROCKET_ENABLED, REACT_APP_LOG_ROCKET_APP_ID } = env;

export const LOG_ROCKET_ENABLED = REACT_APP_LOG_ROCKET_ENABLED === 'true';
export const LOG_ROCKET_APP_ID = REACT_APP_LOG_ROCKET_APP_ID || '';
